<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title class="px-0" style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">
        <v-icon color="#27AB9C" class="" @click="backtoMenu()">mdi-chevron-left</v-icon> รายละเอียดลูกค้า
      </v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายละเอียดลูกค้า
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">รหัสลูกค้า : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ customerCode }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">วันที่เพิ่มข้อมูล : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ customer_dateCreate }}</span>
            </span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">ชื่อลูกค้า : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ customer_name }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">เบอร์ติดต่อ : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ customer_phone }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">กลุ่มลูกค้า : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ customer_channel }}</span></span>
          </v-col>
          <v-col cols="12" align="left">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">หมายเหตุ : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ customer_detail.length > 0 ? customer_detail : '-'  }}</span></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="font20_700 pb-0">ที่อยู่จัดส่ง</v-col>
          <v-col cols="12" class="font16_600"> แสดงรายการที่อยู่ {{countShowAddress}} รายการ จากทั้งหมด {{countAddress}} รายการ</v-col>
          <v-col v-if="addressList.length === 0" align="center" justify="center">
            <span class="font16_msgNoAddress">
              หากไม่มีข้อมูลที่อยู่จัดส่ง จะไม่สามารถสร้างรายการสั่งซื้อได้<br/>
              กรุณาติดต่อแอดมินร้านค้า เพื่อเพิ่มที่อยู่จัดส่งของลูกค้า<br/>
            </span>
          </v-col>
          <v-col v-else class="px-0 pt-0">
            <v-col cols="12" v-for="(item, index) in addressList" :key="index">
              <v-card width="100%" min-height="130px" outlined style="border-color: #5BC3A2;">
                <v-card-title>
                  <span class="font18_700">Ship To {{(noAddress + index)}}</span>
                </v-card-title>
                <v-card-text>
                  <span class="font16_400">{{item.address}}</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" class="my-6" v-if="addressList.length !== 0">
          <v-pagination color="#27AB9C" v-model="pageNumber" :length="pageCount" :total-visible="7" @input="nextPage(pageNumber)">
        </v-pagination>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',
      customerData: [],
      cus_id: '',

      customerCode: '',
      customerDetail: [],
      customer_id: '',
      customer_dateCreate: '',
      customer_name: '',
      customer_phone: '',
      customer_channel: '',
      customer_detail: '',

      countShowAddress: 0,
      countAddress: 0,
      addressList: [],
      noAddress: 1,
      pageNumber: 1,
      pageCount: ''

    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/Order/SalesCustomerDetailMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SalesCustomerDetail' }).catch(() => {})
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  async created () {
    // this.$EventBus.$emit('changeNav')
    this.$EventBus.$emit('enableCartGracz')
    window.addEventListener('storage', function (event) {
      if (event.key === 'oneData' && !event.newValue) {
        window.location.assign('/')
      }
    })
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = this.userDetailSelling.seller_shop_id
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
        this.cus_id = this.customerData.cus_id
      }
      this.getCustomerList()
      this.getCustomerAddress()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SalesCustomerListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SalesCustomerList' }).catch(() => {})
      }
    },
    getCustomerList () {
      console.log('getCustomerList function')
      this.customerDetail = JSON.parse(Decode.decode(localStorage.getItem('GrazcCustomerDetail')))
      this.customer_id = this.customerDetail.cus_id
      this.customerCode = this.customerDetail.cus_code
      this.customer_dateCreate = new Date(this.customerDetail.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })
      this.customer_name = this.customerDetail.cus_name
      this.customer_phone = this.customerDetail.cus_tel
      this.customer_channel = this.customerDetail.channel_name
      this.customer_detail = this.customerDetail.note
      this.pageNumber = 1
      console.log('customerDetail', this.customerDetail)
    },
    async getCustomerAddress () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        cus_id: this.customer_id,
        page: this.pageNumber
      }
      this.addressList = []
      await this.$store.dispatch('actionsGraczListCustomerAddressOfSales', data)
      var res = await this.$store.state.ModuleGraczCustomer.stateGraczListCustomerAddressOfSales
      console.log('res from address API', res)
      if (res.result === 'SUCCESS') {
        this.addressList = res.data.address
        this.pageCount = res.data.total_page
        this.countShowAddress = this.addressList.length
        this.countAddress = res.data.total_address
        if (this.pageNumber > 1) {
          this.noAddress = ((this.pageNumber - 1) * 5) + 1
        } else {
          this.noAddress = 1
        }
        window.scrollTo(0, 0)
      } else {
        this.$swal.fire({ icon: 'warning', text: res.message, showConfirmButton: false, timer: 2000 })
      }
      console.log('this.addressList', this.addressList)
    },
    nextPage (pageNumber) {
      this.pageNumber = pageNumber
      this.getCustomerAddress()
    }
  }
}
</script>

<style>
.font16_400 {
  font-size: 16px; font-weight: 400; line-height: 24px; color: #333333;
}
.font16_600 {
  font-size: 16px; font-weight: 600; line-height: 24px; color: #333333;
}
.font20_700 {
  font-size: 20px; font-weight: 700; line-height: 30px; color: #333333;
}
.font18_700 {
  font-size: 18px; font-weight: 700; line-height: 26px; color: #333333;
}
.font16_msgNoAddress {
  font-size: 16px; font-weight: 400; line-height: 24px; color: #F5222D; text-align: center !important;
}
.text-value {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.fontSizeDetail {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.fontSizeDetailMobile {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
</style>
